/** IVP - Storyline reference */

const SL = {
  get: function (i) {
    return GetPlayer().GetVar(i);
  },
  set: function (i, val) {
    return GetPlayer().SetVar(i, val);
  },
  isMobile: window.isMobile,
};

window.SL = SL;
